import { render, staticRenderFns } from "./group-4.vue?vue&type=template&id=f077b988&scoped=true&"
import script from "./group-4.vue?vue&type=script&lang=js&"
export * from "./group-4.vue?vue&type=script&lang=js&"
import style0 from "./group-4.vue?vue&type=style&index=0&id=f077b988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f077b988",
  null
  
)

export default component.exports